import {createReducer} from '@reduxjs/toolkit'
import { activateRetry } from './retry-action';

export const retryActivateReducer = createReducer(false, builder => 
    builder.addCase(activateRetry, (state, action) => {
        state = action.payload;
        return state;
    })
)